import React from "react";
import NavbarItemLink from "../Navbar/Link";
import Dropdown from "../Dropdown";

const NavbarDropdownTitle = ({ children, ...props }) => {
	return (
		<NavbarItemLink Tag={Dropdown.Title} {...props}>
			{children}
		</NavbarItemLink>
	);
};
NavbarDropdownTitle.propTypes = {
	...Dropdown.Title.propTypes,
};

export default NavbarDropdownTitle;
